import React from 'react'
import Navbar from './Navbar'
import Services from './Services'
import Footer from './Footer'

const AllServices = () => {
  return (
    <div>
      <div>
            {/* <Navbar /> */}
            <Services />
            {/* <Footer /> */}
        </div>
    </div>
  )
}

export default AllServices
